import PropTypes from 'prop-types'
import { Container } from 'reactstrap'

function Denied () {
  return (
    <>
      <h1 className='text-danger'>Access denied</h1>
      <p>
        You do not have access to view page.
        Please submit a case if you believe this is an error.
      </p>
    </>
  )
}

function Main ({ authorized, mainClassName, children }) {
  return (
    <Container fluid id='main' className={mainClassName}>
      {authorized
        ? children
        : <Denied />}
    </Container>
  )
}

Main.propTypes = {
  children: PropTypes.node.isRequired,
  authorized: PropTypes.bool.isRequired
}

export default Main
